import Spinner from "./classes/Spinner.js";
import PhotoMotionSpinner from "./classes/PhotoMotionSpinner.js";

customElements.define("photo-motion-spinner", PhotoMotionSpinner);

export { Spinner };
